import { useLocation } from "react-router-dom";
import { settingsNavPathV3 } from "../helpers/urlHelpers";
import { isVariantBCookieSet } from "../utils/isCookieSet";

export const usePlanPageVariant = () => {
  const { pathname } = useLocation();

  const isPlansPage = [
    settingsNavPathV3.plans.general,
    settingsNavPathV3.plans.billing,
    settingsNavPathV3.plans.brandedApps,
  ].some(path => pathname.includes(path));

  const isVariantBEnabled = Boolean(isVariantBCookieSet());
  const isVariantAEnabled = !isVariantBEnabled;

  const isPlansExperimentLayout =
    isPlansPage && (isVariantAEnabled || isVariantBEnabled);

  return {
    isVariantAEnabled, // variant A
    isVariantBEnabled, // variant B
    isPlansExperimentLayout, // Defines if the plan experiment layout is enabled (without sidebar)
  };
};
